import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { navigationStructure } from "../../utils/navStructure";
import { logoutUser } from "../../config/redux/slice/authSlice";
import { logoutBankUser } from "../../config/redux/slice/bankUserSlice";
import { appUrls } from "../../utils/urls/appUrls";
import { logoutAppUser } from "../../config/redux/slice/appSlice";
import { logoutNotapUser } from "../../config/redux/slice/notapUserSlice";
import { logoutTransfereeUser } from "../../config/redux/slice/transfereeUserSlice";
import { ROLES } from "../../constants";

import notap_logo from "../../assets/images/notap_logo.png";

export default function SideBarLayout() {
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    userData: { user_role },
  } = useSelector((state) => state.authData);

  const certificateNavigation = useMemo(() => {
    if (user_role === ROLES.BANK.TEXT) {
      return navigationStructure.bank_certicate_management;
    }

    if (user_role === ROLES.TRANSFEREE.TEXT) {
      return navigationStructure.certicate_management;
    }

    return navigationStructure.notap_certicate_management;
  }, [user_role]);

  const logout = () => {
    dispatch(logoutUser());
    dispatch(logoutBankUser());
    dispatch(logoutAppUser());
    dispatch(logoutNotapUser());
    dispatch(logoutTransfereeUser());
  };

  return (
    <aside className="left-sidebar sidebar-dark" id="left-sidebar">
      <div id="sidebar" className="sidebar sidebar-with-footer">
        {/* Application Brand */}
        <div className="app-brand">
          <Link to={appUrls.certificates}>
            <img style={{ width: "50px" }} src={notap_logo} alt="Mono" />
            <span className="brand-name text-dark font-weight-bold ml-2">
              NOTAP
            </span>
          </Link>
        </div>

        {/* begin sidebar scrollbar */}
        <div className="sidebar-left" data-simplebar style={{ height: "100%" }}>
          {/* sidebar menu  */}
          <ul className="nav sidebar-inner" id="sidebar-menu">
            {user_role === ROLES.ADMIN.TEXT ? (
              <>
                <li className="section-title">Admin</li>

                <li
                  className={
                    appUrls.adminHome === location.pathname ? "active" : ""
                  }
                >
                  <Link
                    to={appUrls.adminHome}
                    className="sidenav-item-link"
                    href="index.html"
                  >
                    <i className="mdi mdi-shield-account"></i>
                    <span className="nav-text">Home</span>
                  </Link>
                </li>

                <li
                  className={
                    appUrls.adminCertificates === location.pathname
                      ? "active"
                      : ""
                  }
                >
                  <Link
                    to={appUrls.adminCertificates}
                    className="sidenav-item-link"
                    href="index.html"
                  >
                    <i className="mdi mdi-certificate"></i>
                    <span className="nav-text">Certificates</span>
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li className="section-title">
                  Confirmation of Reasonableness
                </li>

                {certificateNavigation.map((option) => (
                  <li
                    key={option.id}
                    className={
                      option.url === location.pathname ||
                      option.subPath.includes(location.pathname)
                        ? "active"
                        : ""
                    }
                  >
                    <Link to={option.url} className="sidenav-item-link">
                      <i className={option.icon}></i>
                      <span className="nav-text">{option.name}</span>
                    </Link>
                  </li>
                ))}
              </>
            )}

            {![
              ROLES.TRANSFEREE.TEXT,
              ROLES.BANK.TEXT,
              ROLES.ADMIN.TEXT,
            ].includes(user_role) && (
              <>
                <li className="section-title">Digital Letter</li>

                {navigationStructure.digital_letter.map((option) => (
                  <li
                    key={option.id}
                    className={
                      option.url === location.pathname ||
                      option.subPath.includes(location.pathname)
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to={option.url}
                      className="sidenav-item-link"
                      href="index.html"
                    >
                      <i className={`${option.icon}`}></i>
                      <span className="nav-text">{option.name}</span>
                    </Link>
                  </li>
                ))}
              </>
            )}
          </ul>
        </div>

        <div className="sidebar-footer">
          <div className="sidebar-footer-content">
            <ul className="d-flex align-items-center justify-content-center">
              <li className="first-item">
                <button onClick={logout} className="font-weight-bold">
                  LOGOUT
                </button>
              </li>
              <li>
                <button onClick={logout} title="Logout">
                  <i className="mdi mdi-logout"></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </aside>
  );
}
